export const SESSION_STORAGE_NAMES = {
  CHANNEL_ID: 'channel_id',
  CHANNEL: 'channel',
  PROJECT_ID: 'projectId',
  PROJECT_DETAIL_ID: 'projectDetailId',
  INITIAL_URL: 'initialUrl',
  INVITATION_CODE: 'invitationCode',
};

export const getSessionStorage = (name: string): string | null => {
  if (!name) return null;

  return sessionStorage.getItem(name);
};

export const setSessionStorage = (name: string, value: any): void => {
  if (!name) return;
  if (value === undefined || value === null) return;

  sessionStorage.setItem(name, value);
};

export const removeSessionStorage = (name: string): void => {
  if (!name) return;

  sessionStorage.removeItem(name);
};
